import { Package, Flag, OctagonX, ArrowDown, Trash2 } from "lucide-react";

export default function RoutePreview({ origin, stops, destination, onRemoveStop, routeInfo }) {
  const nodes = [
    { icon: Package, label: "EMBARQUE", addr: origin, color: "bg-navy" },
    ...stops.map((s, i) => ({
      icon: OctagonX,
      label: `PARADA ${i + 1}`,
      addr: s,
      color: "bg-[#F5B301]",
      stopIndex: i,
    })),
    { icon: Flag, label: "DESTINO FINAL", addr: destination, color: "bg-navy" },
  ];

  const fmt = (a) =>
    [a.logradouro && a.numero ? `${a.logradouro}, ${a.numero}` : a.logradouro, a.cidade && a.uf ? `${a.cidade} - ${a.uf}` : a.cidade]
      .filter(Boolean)
      .join(" · ") || a.cep || "A preencher";

  return (
    <div data-testid="route-preview" className="bg-white rounded-2xl border border-slate-100 shadow-sm p-4">
      <p className="text-xs font-semibold tracking-wider uppercase text-slate-400 mb-3">Sua rota</p>
      <div className="space-y-0">
        {nodes.map((n, i) => (
          <div key={i}>
            <div className="flex items-center gap-3" data-testid={`route-node-${i}`}>
              <div className={`w-9 h-9 rounded-full ${n.color} flex items-center justify-center shrink-0`}>
                <n.icon className={`w-4 h-4 ${n.color === "bg-navy" ? "text-[#F5B301]" : "text-navy"}`} />
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-xs font-bold text-navy tracking-wide">{n.label}</p>
                <p className="text-[11px] text-slate-500 truncate">{fmt(n.addr)}</p>
                {n.stopIndex !== undefined && (
                  <p className="text-[10px] text-amber-600 font-semibold">A combinar com o motorista</p>
                )}
              </div>
              {n.stopIndex !== undefined && (
                <button
                  data-testid={`remove-stop-${n.stopIndex}-btn`}
                  onClick={() => onRemoveStop(n.stopIndex)}
                  className="p-2 text-red-400 hover:text-red-600 active:scale-90 transition"
                >
                  <Trash2 className="w-4 h-4" />
                </button>
              )}
            </div>
            {i < nodes.length - 1 && (
              <div className="ml-[18px] py-1 text-slate-300">
                <ArrowDown className="w-4 h-4" />
              </div>
            )}
          </div>
        ))}
      </div>
      {routeInfo && (
        <div className="mt-3 pt-3 border-t border-slate-100 flex items-center justify-between" data-testid="route-distance-info">
          <span className="text-xs text-slate-500">Distância estimada</span>
          <span className="font-heading font-bold text-navy text-sm">{routeInfo.distance_km} km · ~{routeInfo.duration_min} min</span>
        </div>
      )}
    </div>
  );
}
